<template>
<code>
&lt;head><br>
&nbsp;&nbsp;&nbsp;&nbsp;&lt;script src="https://swarm.video/swarm.js">&lt;/script><br>
&nbsp;&nbsp;&nbsp;&nbsp;&lt;link rel="stylesheet"
href="https://vjs.zencdn.net/7.6.0/video-js.css">&lt;/script><br>
&nbsp;&nbsp;&nbsp;&nbsp;&lt;script src="https://vjs.zencdn.net/7.6.0/video.js">&lt;/script><br>
&nbsp;&nbsp;&nbsp;&nbsp;&lt;script src="https://cdn.jsdelivr.net/npm/videojs-contrib-hls.js@latest">&lt;/script><br>
&lt;/head><br>
&lt;body><br>
&nbsp;&nbsp;&nbsp;&nbsp;&lt;video id="video" class="video-js vjs-default-skin" autoplay
muted controls>
&lt;/video><br>
&lt;/body><br>
&lt;script>
<br>
let engine = new p2pml.hlsjs.Engine({segments: {swarmId: "CustomSwarmId"},loader: {httpUseRanges:false, WaitForTracker: true, WaitForTrackerCounter:4500}}); <br>
let player = videojs("video", {<br>
&nbsp;&nbsp;&nbsp;&nbsp;html5: {<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;hlsjsConfig: {<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;liveSyncDurationCount: 7,<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;loader: engine.createLoaderClass()<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;}<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; }<br>
&nbsp;&nbsp;&nbsp;&nbsp;});<br>
p2pml.hlsjs.initVideoJsContribHlsJsPlayer(player);<br>
player.src({<br>
&nbsp;&nbsp;&nbsp;&nbsp;src:
'https://wowza.peer5.com/live/smil:bbb_abr.smil/playlist.m3u8',<br>
&nbsp;&nbsp;&nbsp;&nbsp;type: "application/x-mpegURL"<br>
});<br>


                                &lt;/script><br>


                            </code>
</template>

<script>
export default {
  name: "jwplayer",
 
  
};
</script>
